export function PingPongLandLogo() {
  return (
    <>
      <svg
        className="brand-logo-mark"
        viewBox="0 0 64 64"
        aria-hidden="true"
        focusable="false"
      >
        <rect className="logo-tile" x="2" y="2" width="60" height="60" rx="16" />
        <path className="logo-cube-top" d="M32 10 50 20.5 32 31 14 20.5Z" />
        <path className="logo-cube-left" d="M14 20.5 32 31v21L14 41.5Z" />
        <path className="logo-cube-right" d="M32 31 50 20.5v21L32 52Z" />
        <circle className="logo-button" cx="32" cy="20.5" r="3.2" />
        <circle className="logo-detail" cx="21.5" cy="32.5" r="1.8" />
        <circle className="logo-detail" cx="25.5" cy="41" r="1.8" />
        <path className="logo-connector" d="M41 28v13M35.5 34.5h11" />
      </svg>
      <span className="brand-wordmark">
        <strong>핑퐁랜드</strong>
        <small>PINGPONG LAND</small>
      </span>
    </>
  )
}
